import b_ from "b_";
// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__MFU2t","title4":"styles_title4__TXD6R","body1":"styles_body1__aoKtO","body2":"styles_body2__E73N2","caption1":"styles_caption1__fb6fo","caption2":"styles_caption2__E2wsY","nav":"styles_nav__ce3lm","navIcon":"styles_navIcon__KWYnQ","title3":"styles_title3__9Ug+W"};
export const b = b_.with('icon');